<template>
  <section class="space-y-5">
    <header>
      <h2 class="text-lg font-semibold text-gray-900">Programs (footer links)</h2>
      <p class="text-sm text-gray-500">Foundation program links shown in the footer.</p>
    </header>

    <TemplateRepeatableList
      v-model="programsProxy"
      :max-items="20"
      :new-item="newProgram"
      item-noun="program"
    >
      <template #item="{ item }">
        <div class="grid grid-cols-2 gap-2">
          <input
            v-model="item.name"
            type="text"
            maxlength="120"
            placeholder="Name"
            class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
          >
          <input
            v-model="item.link"
            type="text"
            maxlength="500"
            placeholder="Link"
            class="w-full rounded-md border-gray-300 text-sm focus:border-pink-500 focus:ring-pink-500"
          >
        </div>
      </template>
    </TemplateRepeatableList>
  </section>
</template>

<script>
import TemplateRepeatableList from '../TemplateRepeatableList.vue';

export default {
  name: 'ProgramsSectionEditor',
  components: { TemplateRepeatableList },
  props: {
    programs: { type: Array, required: true },
  },
  emits: ['update:programs'],
  computed: {
    programsProxy: {
      get() { return this.programs; },
      set(value) { this.$emit('update:programs', value); },
    },
  },
  methods: {
    newProgram() {
      return { name: '', link: '' };
    },
  },
};
</script>
